// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/c52ca09e/" + chunkId + "." + __webpack_require__.h() + ".vc52ca09e.js";
};